"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UICardSection;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UICardSection(_ref) {
  var className = _ref.className,
      children = _ref.children,
      flush = _ref.flush,
      scrollable = _ref.scrollable,
      other = (0, _objectWithoutProperties2.default)(_ref, ["className", "children", "flush", "scrollable"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classNames.default)('private-card__section', 'has--vertical-spacing', className, {
      'private-card__section--flush': flush,
      'private-card__section--scrollable': scrollable
    })
  }), children);
}

UICardSection.defaultProps = {
  flush: false,
  scrollable: false
};
UICardSection.propTypes = {
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool,
  scrollable: _react.PropTypes.bool
};
UICardSection.displayName = 'UICardSection';
module.exports = exports.default;